import { FormTemplateDto } from "../models/formTemplate/formTemplateDto";
import { ApiResponse, apiCall } from "./apiClient";

export interface FormTemplateSaveDto {
    id?: string;
    rowId?: string;
    name: string;
    jsonSchema: string;
    targetObjectType?: string | null;
    isActive?: boolean;
}

export const getFormTemplates = (
    activeOnly?: boolean,
    signal?: AbortSignal
): Promise<ApiResponse<FormTemplateDto[]>> => {
    const params = activeOnly !== undefined ? { activeOnly } : undefined;
    return apiCall<FormTemplateDto[], typeof params>(
        "FormTemplates",
        "GET",
        params,
        signal
    );
};

export const getFormTemplate = (
    id: string,
    signal?: AbortSignal
): Promise<ApiResponse<FormTemplateDto>> => {
    return apiCall<FormTemplateDto>(
        `FormTemplates/${encodeURIComponent(id)}`,
        "GET",
        null,
        signal
    );
};

export const saveFormTemplate = (
    dto: FormTemplateSaveDto
): Promise<ApiResponse<FormTemplateDto>> => {
    return apiCall<FormTemplateDto, FormTemplateSaveDto>(
        "FormTemplates",
        "POST",
        dto
    );
};

export const deleteFormTemplate = (id: string): Promise<ApiResponse<void>> => {
    return apiCall<void>(`FormTemplates/${encodeURIComponent(id)}`, "DELETE");
};
